
define('text!modules/targeting/audience/templates/grid_footer.html',[],function () { return '<div class="stack browse-path" data-bind="browse_path">{{{browse_path}}}<span class="strong">{{{browse_path_end}}}&nbsp;</span></div>';});

